import TEMPLATE_URL from 'emun.salesrep/territory-manager/zipcode/parser/zipcode-parser.htm'
import controller from 'emun.salesrep/territory-manager/zipcode/parser/zipcode-parser.controller'
import modals from 'webmodals/modals'

const NOOP = () => { };

export default ({
    size = 'md',
    backdrop = 'static',
    templateUrl = TEMPLATE_URL,
    title = 'Zipcode Bulk Pad...',
    subTitle = 'Enter zipcodes separated by comma or white-space',
    view = 'cards',
    selected = {},
    onToggle = NOOP,
    onZipcodeSelected = NOOP,
    onZipcodeDeselected = NOOP,
} = {}) => modals.open({
        size,
        backdrop,
        templateUrl,
        controller,
        bindToController: true,
        controllerAs: '$ctrl',
        resolve: {
            options: () => ({
                title,
                subTitle,
                onZipcodeSelected,
                onZipcodeDeselected,
                view,
            })
        }
    }).result;